export default "__VITE_ASSET__OJzBjR9g__"